import {
  ChangeStatusButton,
  DeleteButton,
  EditButton,
} from "@/components/IconButton/variants";
import StatusBadge from "@/components/StatusBadge";
import { STATUS } from "@/constant/statusConstants";
import { useModalConfirmation } from "@/context/ModalConfirmationContext";
import { useCallback } from "react";

export const useColumns = () => {
  const { openModalConfirmation } = useModalConfirmation();

  const handleModalAction = useCallback(
    (type, data) => {
      openModalConfirmation({
        type,
        title: "test",
        id: data?.id,
        apiUrl: "xx",
      });
    },
    [openModalConfirmation]
  );

  return [
    {
      accessorKey: "transaction_id",
      header: "Transaction ID",
    },
    {
      accessorKey: "seller",
      header: "Seller",
      cell: ({ row }) => <div>{row.original?.buyer?.first_name}</div>,
    },
    {
      accessorKey: "buyer",
      header: "Buyer",
      cell: ({ row }) => <div>{row.original?.seller?.first_name}</div>,
    },
    {
      accessorKey: "seller_rating",
      header: "Evaluation Seller - Buyer",
    },
    {
      accessorKey: "seller_comment",
      header: "Comment",
    },
    {
      accessorKey: "seller_status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "actions-seller",
      header: "Actions",
      cell: ({ row }) =>
        row.original.seller_status !== null &&
        row.original.seller_status !== STATUS.PENDING && (
          <div className="w-auto flex gap-x-1 justify-center">
            <ChangeStatusButton
              isActive={row.original.status === STATUS.ACTIVE}
              onClick={() => handleModalAction("changeStatus", row.original)}
            />
            <EditButton
              onClick={() => handleModalAction("edit", row.original)}
            />
            <DeleteButton
              onClick={() => handleModalAction("delete", row.original)}
            />
          </div>
        ),
    },
    {
      accessorKey: "buyer_rating",
      header: "Evaluation Buyer - Seller",
    },
    {
      accessorKey: "buyer_comment",
      header: "Comment",
    },
    {
      accessorKey: "buyer_status",
      header: "Status",
      cell: ({ row }) => (
        <StatusBadge
          status={(row.original.buyer_status, row.original.buyer_status)}
        />
      ),
    },
    {
      accessorKey: "actions-buyer",
      header: "Actions",
      cell: ({ row }) =>
        row.original.buyer_status !== STATUS.PENDING && (
          <div className="w-auto flex gap-x-1 justify-center">
            <ChangeStatusButton
              isActive={row.original.status === STATUS.ACTIVE}
              onClick={() => handleModalAction("changeStatus", row.original)}
            />
            <EditButton
              onClick={() => handleModalAction("edit", row.original)}
            />
            <DeleteButton
              onClick={() => handleModalAction("delete", row.original)}
            />
          </div>
        ),
    },
  ];
};
